import React from 'react';
import './MatheldaNav.css'

const MatheldaNav = () => {
    return ( 
        <nav className="matheldaNav">
            <ul className="matheldaNav__list">
                <li>latest work</li>
                <li>blog</li>
                <li>schedule call</li>
            </ul>
        </nav>
     );
}
 
export default MatheldaNav;